import { Axios } from 'src/class/Axios';
import { AXIOS_URL } from 'src/util/Util';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

const mixinUpload = {
  props: {
    routeUpload: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      acceptedFilesString: 'image/jpeg,image/png,image/jpg',
      fileList: [],
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      uploadData: {
        id: null,
      },
    };
  },
  computed: {
    getAxiosURL() {
      return AXIOS_URL;
    },
  },
  methods: {
    submitUpload(registerId) {
      if (isset(this.model.fileList)) {
        this.$set(this.uploadData, 'id', registerId);
        this.$refs.uploadSoilTypeImage.submit();
      }
    },
    handleChange(file, fileList) {
      const maxSizeInKB = 5000;
      const isSizeValid = file.size / 1024 > maxSizeInKB;
      if (isSizeValid) {
        SweetAlert.warning(i18n.t('sweet_alert.common.maximum_size_per_file'));
        this.$refs.uploadSoilTypeImage.uploadFiles.pop();
      }

      this.fileList = fileList;
      this.model.fileList = fileList.map((file_) => file_.name);
    },
    handleRemove(_, fileList) {
      if (this.model.image) {
        const dataRemove = {
          route: this.routeUpload,
          path: this.model.image,
        };
        Axios.postMasters(dataRemove)
          .then()
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
      this.fileList = fileList;
      this.model.fileList = fileList.map((file) => file.name);
    },
    handleExceed(_, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.common.the_limit')}
        ${this.$refs.uploadSoilTypeImage.limit}, ${i18n.t(
          'sweet_alert.common.already_selected'
        )}
        ${fileList.length}  ${i18n.t('sweet_alert.common.files')}.`
      );
    },
    handleSuccess(response) {
      if (response.error) {
        SweetAlert.warning(response.error);
      } else {
        const beforeUpload = sessionStorage.getItem('before-upload');
        if (beforeUpload) {
          sessionStorage.removeItem('before-upload');
          this.$emit('closeModal');
        }
        this.fileList = [];
      }
    },
  },
};

export default mixinUpload;
